__turbopack_context__.v({
  "root": "BlogList-module-scss-module__4awEjG__root",
  "swiper": "BlogList-module-scss-module__4awEjG__swiper",
});
